// Flags de runtime inyectados en window.* por config.js (envsubst en docker-compose, ConfigMap en K8s).
// Cambiarlos no requiere rebuild: basta con el valor del entorno y reiniciar el pod.

function parseList(value) {
  return String(value ?? '')
    .split(/[,;\s]+/)
    .map((item) => item.trim().toLowerCase())
    // "$VAR" literal: la variable no se sustituyo al generar config.js.
    .filter((item) => item && !item.startsWith('$'));
}

/**
 * "Importar eventos de LexON V2" solo se ofrece con window.IMPORT_EVENT_LEXON_V2 === 'true'.
 * Si ademas hay window.IMPORT_EVENT_LEXON_V2_USERS (lista separada por comas), solo para esos usuarios:
 * se compara, sin distinguir mayusculas, con cualquiera de las identidades recibidas (cuenta de correo
 * conectada o usuario de Lefebvre).
 *
 * @param {Array<string|null|undefined>} identities
 * @returns {boolean}
 */
export function isImportEventsLexonV2Enabled(identities = []) {
  if (String(window.IMPORT_EVENT_LEXON_V2 ?? '').trim().toLowerCase() !== 'true') return false;

  const allowed = parseList(window.IMPORT_EVENT_LEXON_V2_USERS);
  if (allowed.length === 0) return true;

  return identities
    .filter(Boolean)
    .some((id) => allowed.includes(String(id).trim().toLowerCase()));
}
